import React, { useState, useEffect, useRef } from 'react';
import { Button } from '@mui/material';
import { connect, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { fetchCampaignsForAdvertiser, fetchSkanCampaignsForAdvertiser } from '../../redux/advertiser/advertiserActions';
import { applyFilter, fetchDashboardDataNonSkan, fetchDashboardDataSkan } from '../../redux/campaign/campaignActions';
import { fetchReportDataForNonSkanReporting, fetchReportDataForSkanReporting } from '../../redux/reporting/reportingActions';
import { fetchCreativeDataNonSkan, fetchCreativeDataSkan } from '../../redux/creative/creativeActions';
import { fetchWowReportSkanData, fetchWowReportNonSkanData } from '../../redux/wow/wowActions';
import { fetchRawEventSkanData, fetchRawEventNonSkanData } from '../../redux/rawEvent/rawEventActions';
import { fetchStateReportSkanData, fetchStateReportNonSkanData } from '../../redux/stateReport/stateReportActions';
import { fetchDoDDataNonSkan, fetchDoDDataSkan } from '../../redux/dod/dodActions';
import dayjs from 'dayjs';

const ApplyJSTFilterPage = ({
  isSkan,
  selected_campaigns,
  applyFilter,
  applyFilterStatus,
  fetchReportDataForNonSkanReporting,
  fetchReportDataForSkanReporting,
  firstFilter,
  fetchDashboardDataNonSkan,
  fetchDashboardDataSkan,
  fetchCreativeDataNonSkan,
  fetchCreativeDataSkan,
  fetchWowReportSkanData,
  fetchWowReportNonSkanData,
  fetchRawEventNonSkanData,
  fetchRawEventSkanData,
  fetchStateReportSkanData,
  fetchStateReportNonSkanData,
  fetchDoDDataNonSkan,
  fetchDoDDataSkan,
  sfId,
  startDate,
  endDate,
  wowStartDate,
  wowEndDate,
  advertiser_campaign_fetching,
  performanceLoading,
  widzardLoading,
  reportLoading,
  userDashboardPermissions
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname.split('/')[1];

  const [disableFilterButton, setDisableFilterButton] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [hasApplied, setHasApplied] = useState(false);

  const advertiserGuid = localStorage.getItem('advertiserId');

  // Get Effective Dates for WoW and T-2 and T-1
  const getEffectiveDates = () => {
    if (currentPath === 'wow') {
      console.log('Using WoW dates:', { wowStartDate, wowEndDate });
      return {
        startDate: wowStartDate,
        endDate: wowEndDate
      };
    }
    console.log('Using default dates:', { startDate, endDate });
    return { startDate, endDate };
  };

  //Ensures this useEffect never fires again,
  // const didRunRef = useRef(false);
  const autoApplied = useRef(false);

  // When button clicked fetch campaigns for advertiser
  const applyFilterButton = () => {
    applyFilter(true);

    // USE getEffectiveDates():
    const { startDate: effectiveStart, endDate: effectiveEnd } = getEffectiveDates();

    // VALIDATE Start and End Dates
    if (!effectiveStart || !effectiveEnd) {
      console.error('❌ Dates not set!');
      if (currentPath === 'wow') {
        alert('Please select at least one quarter before applying filter.');
      }
      return;
    }

    // Check if user has no permissions (empty arrays = show all data)
    const hasNoPermissions =
      userDashboardPermissions &&
      userDashboardPermissions.tabs &&
      userDashboardPermissions.tabs.length === 0 &&
      userDashboardPermissions.widgets &&
      userDashboardPermissions.widgets.length === 0;

    if (hasNoPermissions) {
      console.log('🔍 ApplyFilter JST - User has no permissions, loading all data directly');
      // If no permissions, load data directly without campaign filtering
      if (currentPath === 'dashboard') {
        isSkan ? fetchDashboardDataSkan(selected_campaigns) : fetchDashboardDataNonSkan(selected_campaigns);
      } else if (currentPath === 'reporting') {
        isSkan ? fetchReportDataForSkanReporting(selected_campaigns) : fetchReportDataForNonSkanReporting(selected_campaigns);
      } else if (currentPath === 'creative') {
        isSkan ? fetchCreativeDataSkan(selected_campaigns) : fetchCreativeDataNonSkan(selected_campaigns);
      } else if (currentPath === 'rawevents') {
        isSkan ? fetchRawEventSkanData(selected_campaigns) : fetchRawEventNonSkanData(selected_campaigns);
      } else if (currentPath === 'statereport') {
        isSkan ? fetchStateReportSkanData(selected_campaigns) : fetchStateReportNonSkanData(selected_campaigns);
      } else if (currentPath === 'wow') {
        isSkan ? fetchWowReportSkanData(selected_campaigns) : fetchWowReportNonSkanData(selected_campaigns);
      } else if (currentPath === 'dod') {
        isSkan ? fetchDoDDataSkan(selected_campaigns) : fetchDoDDataNonSkan(selected_campaigns);
      }

      console.log('🔍 ApplyFilter JST - Data loading initiated, will reset applyFilter when data loads');
      // Don't reset applyFilter immediately - let the data loading success handlers do it
      return;
    }

    // Campaign Fetch condition
    const shouldFetchCampaigns = !selected_campaigns || selected_campaigns.length === 0;

    if (shouldFetchCampaigns && advertiserGuid && effectiveStart && effectiveEnd) {
      if (isSkan) {
        dispatch(fetchSkanCampaignsForAdvertiser(advertiserGuid, sfId, effectiveStart, effectiveEnd));
      } else {
        dispatch(fetchCampaignsForAdvertiser(advertiserGuid, sfId, effectiveStart, effectiveEnd));
      }
    } else {
      console.warn('Missing advertiserGuid/startDate/endDate');
    }
  };

  // When campaigns update in Redux trigger data fetch
  useEffect(() => {
    if (applyFilterStatus && selected_campaigns?.length > 0) {
      console.log('Apply JST Filter triggered for path:', currentPath, 'campaigns:', selected_campaigns.length);

      if (currentPath === 'dashboard') {
        isSkan ? fetchDashboardDataSkan(selected_campaigns) : fetchDashboardDataNonSkan(selected_campaigns);
      } else if (currentPath === 'reporting') {
        isSkan ? fetchReportDataForSkanReporting(selected_campaigns) : fetchReportDataForNonSkanReporting(selected_campaigns);
      } else if (currentPath === 'creative') {
        isSkan ? fetchCreativeDataSkan(selected_campaigns) : fetchCreativeDataNonSkan(selected_campaigns);
      } else if (currentPath === 'rawevents') {
        isSkan ? fetchRawEventSkanData(selected_campaigns) : fetchRawEventNonSkanData(selected_campaigns);
      } else if (currentPath === 'statereport') {
        isSkan ? fetchStateReportSkanData(selected_campaigns) : fetchStateReportNonSkanData(selected_campaigns);
      } else if (currentPath === 'wow') {
        isSkan ? fetchWowReportSkanData(selected_campaigns) : fetchWowReportNonSkanData(selected_campaigns);
      } else if (currentPath === 'dod') {
        isSkan ? fetchDoDDataSkan(selected_campaigns) : fetchDoDDataNonSkan(selected_campaigns);
      }

      // reset applyFilter flag after fetch
      applyFilter(false);
    }
  }, [applyFilterStatus, selected_campaigns, currentPath, isSkan]);

  // Disable button when loading
  useEffect(() => {
    const isLoading = applyFilterStatus || advertiser_campaign_fetching || performanceLoading || widzardLoading || reportLoading;
    console.log('🔍 ApplyFilter JST - Loading states:', {
      applyFilterStatus,
      advertiser_campaign_fetching,
      performanceLoading,
      widzardLoading,
      reportLoading,
      isLoading,
      disableFilterButton
    });
    setDisableFilterButton(isLoading);
  }, [applyFilterStatus, advertiser_campaign_fetching, performanceLoading, widzardLoading, reportLoading]);

  return (
    <div className="filter-Button">
      <Button variant="outlined" onClick={applyFilterButton} disabled={disableFilterButton}>
        Apply Filter
      </Button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  selected_campaigns: state.advertiserReducer.selected_campaigns,
  advertiser_campaign_fetching: state.advertiserReducer.advertiser_campaign_fetching,
  performanceLoading: state.campaignReducer.performanceLoading,
  widzardLoading: state.campaignReducer.widzardLoading,
  reportLoading: state.campaignReducer.reportLoading,
  isSkan: state.campaignReducer.isSkan,
  applyFilterStatus: state.campaignReducer.applyFilter,
  firstFilter: state.campaignReducer.firstFilter,
  timeZone: state.advertiserReducer.timeZone,
  sfId: state.advertiserReducer.sfId,
  startDate: state.campaignReducer.start_date,
  endDate: state.campaignReducer.end_date,
  userDashboardPermissions: state.userReducer.userDashboardPermissions,
  wowStartDate: state.wowReducer.wow_start_date,
  wowEndDate: state.wowReducer.wow_end_date
});

const mapDispatchToProps = {
  fetchCampaignsForAdvertiser: fetchCampaignsForAdvertiser,
  fetchSkanCampaignsForAdvertiser: fetchSkanCampaignsForAdvertiser,
  applyFilter: applyFilter,
  fetchReportDataForNonSkanReporting: fetchReportDataForNonSkanReporting,
  fetchReportDataForSkanReporting: fetchReportDataForSkanReporting,
  fetchDashboardDataNonSkan: fetchDashboardDataNonSkan,
  fetchDashboardDataSkan: fetchDashboardDataSkan,
  fetchCreativeDataNonSkan: fetchCreativeDataNonSkan,
  fetchCreativeDataSkan: fetchCreativeDataSkan,
  fetchWowReportSkanData: fetchWowReportSkanData,
  fetchWowReportNonSkanData: fetchWowReportNonSkanData,
  fetchRawEventSkanData: fetchRawEventSkanData,
  fetchRawEventNonSkanData: fetchRawEventNonSkanData,
  fetchStateReportSkanData: fetchStateReportSkanData,
  fetchStateReportNonSkanData: fetchStateReportNonSkanData,
  fetchDoDDataSkan: fetchDoDDataSkan,
  fetchDoDDataNonSkan: fetchDoDDataNonSkan
};

export default connect(mapStateToProps, mapDispatchToProps)(ApplyJSTFilterPage);
